<template>
    <section class="header-button-container">
        <div class="header-button">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-button__title"
                v-html="pageHeader.title"
            ></div>

            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="pageHeader.subtitle"
                class="header-button__subtitle"
                v-html="pageHeader.subtitle"
            ></div>

            <OrangeButton
                :text="pageHeader.button_text"
                :url="pageHeader.button_url"
                class="header-button__button"
            />

            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-button__button-desc"
                v-html="pageHeader.button_description"
            ></div>

            <!-- eslint-disable vue/no-v-html -->
            <SellingPoints
                v-if="pageHeader.selling_points"
                :selling-points="pageHeader.selling_points"
            />

            <Media :type="pageHeader.media_type" />
        </div>
    </section>
</template>

<script setup>
import Media from '../../header-components/media/watson-theme-header-media.vue';
import SellingPoints from '../../header-components/selling-points/watson-theme-selling-points.vue';
import { default as OrangeButton } from '../../../../../components/buttons/orange/watson-theme-orange-button.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use 'watson-theme-header-button';
</style>
